import { render, staticRenderFns } from "./deleteMetaData.vue?vue&type=template&id=47983710&scoped=true&"
import script from "./deleteMetaData.vue?vue&type=script&lang=js&"
export * from "./deleteMetaData.vue?vue&type=script&lang=js&"
import style0 from "./deleteMetaData.vue?vue&type=style&index=0&id=47983710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47983710",
  null
  
)

export default component.exports